import React, { useEffect, useRef, useState } from "react";
import { TextField, Button, IconButton, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// import { openai } from "@ai-sdk/openai";
// import { streamText } from "ai";

const ChatbotModal = ({ isOpen, onClose }) => {
  const [messages, setMessages] = useState<any[]>([]);
  const [input, setInput] = useState("");

  const chatContainerRef = useRef<HTMLDivElement>(null);

  const handleSend = (e) => {
    e.preventDefault();
    if (!input.trim()) return;

    const userMessage = { role: "user", content: input };
    setMessages((prev) => [...prev, userMessage]);
    setInput("");

    // const result = streamText({
    //   model: openai("gpt-4o"),
    //   messages: [...messages, userMessage],
    // });

    setTimeout(() => {
      setMessages((prev) => [
        ...prev,
        { role: "assistant", content: `Echo: ${input}` },
      ]);
    }, 500);
  };

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [messages]);

  if (!isOpen) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        width: "400px",
        backgroundColor: "#fff",
        borderRadius: "10px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        zIndex: 1000,
      }}
    >
      <Box
        sx={{
          padding: "10px",
          backgroundColor: "#3f51b5",
          color: "#fff",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>Chatbot</span>
        <IconButton size="small" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Box
        style={{
          flexGrow: 1,
          padding: "10px",
          overflowY: "auto",
          height: "300px",
          borderBottom: "1px solid #ddd",
        }}
        ref={chatContainerRef}
      >
        {messages.map((msg, index) => (
          <div
            key={index}
            style={{
              textAlign: msg.role === "user" ? "right" : "left",
              marginBottom: "10px",
              color: msg.role === "user" ? "green" : "red",
            }}
          >
            <strong>{msg.role === "user" ? "You" : "Bot"}:</strong>{" "}
            {msg.content}
          </div>
        ))}
      </Box>
      <form
        onSubmit={handleSend}
        style={{
          display: "flex",
          padding: "10px",
          borderTop: "1px solid #ddd",
          backgroundColor: "#eee",
        }}
      >
        <TextField
          variant="outlined"
          size="small"
          fullWidth
          sx={{
            "& .MuiOutlinedInput-root": {
              bgcolor: "primary.contrastText",
              color: "primary.main",
              fontFamily: "Proxima Nova",
            },
          }}
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Type a message..."
        />
        <Button
          type="submit"
          variant="contained"
          size="small"
          style={{ marginLeft: "8px" }}
        >
          Send
        </Button>
      </form>
    </Box>
  );
};

export default ChatbotModal;
